import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const selectCompensationComplianceConfig = createSelector(
  getCompany,
  ({ compensationCompliance }) => compensationCompliance,
);
